export enum FiatCurrencyCode {
  RUB = 'RUB',
  BOB = 'BOB',
  KGS = 'KGS',
}
